module.exports = __webpack_public_path__ + "static/media/app-brasal-inc-desktop.40d18f6d.jpg";